import React, { useState, useEffect } from "react";
import moment from "moment-jalaali";

const CountdownTimer = ({ targetDate }) => {
  const [timeLeft, setTimeLeft] = useState({});

  useEffect(() => {
    const calculateTimeLeft = () => {
      const now = moment();
      const target = moment(targetDate, "jYYYY/jM/jD").set({
        hour: 23,
        minute: 59,
        second: 59,
        millisecond: 59,
      }); // تنظیم ساعت روی 23:59
      const difference = target.diff(now);

      if (difference <= 0) {
        setTimeLeft({ days: 0, hours: 0, minutes: 0, seconds: 0 });
        return;
      }

      const duration = moment.duration(difference);
      setTimeLeft({
        days: Math.floor(duration.asDays()),
        hours: duration.hours(),
        minutes: duration.minutes(),
        seconds: duration.seconds(),
      });
    };

    const timer = setInterval(calculateTimeLeft, 1000);
    return () => clearInterval(timer);
  }, [targetDate]);

  return (
    <div className="d-flex ltr text-danger fs-075 reverse-timer">
      <div className="text-center ">
        <div className="timer-number">{timeLeft.days} : </div>
      </div>
      <div className="text-center">
        <div className="timer-number">{timeLeft.hours} : </div>
      </div>
      <div className="text-center ">
        <div className="timer-number">{timeLeft.minutes} : </div>
      </div>
      <div className="text-center ">
        <div className="timer-number">{timeLeft.seconds} </div>
      </div>
    </div>
  );
};
export default CountdownTimer;
